exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1v8fm{position:relative;background-color:#fff;padding:10px 10px 0;min-height:240px;border-bottom:1px solid #d8d8d8;z-index:1;margin:10px 0}.qKgxb{font-size:20px;font-weight:700;color:#000}._2MEQ5{width:183px;padding:0 5px}._2MEQ5 div{background-color:transparent}.wu4DK{padding:5px 0 15px 5px}._24xQV{padding-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_1v8fm",
	"title": "qKgxb",
	"advertItem": "_2MEQ5",
	"header": "wu4DK",
	"carouselBody": "_24xQV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/spareparts/components/AnotherSpares/AnotherSpares.css
// module id = 3129
// module chunks = 36